const PaymentConstants = {
    status: {
        ALL: 'all',
        PENDING: 'pending',
        PAID: 'paid',
        EXPIRED: 'expired',
        FAILED: 'failed',
    },
    type: {
        ALL: 'all',
        SURVEY: 'Survey',
        PLAN: 'Plan',
    },
    surveyService: {
        BASE: 'base',
        TARGET: 'target',
    },
    fieldName: {
        monthly_personal_income: '8. Thu nhập cá nhân',
        gender: '2. Giới tính',
        dob: '3. Độ tuổi',
        address: '1. Khu vực',
        monthly_family_income: '9. Thu nhập gia đình',
        marriage: '4. Tình trạng hôn nhân',
        child: '5. Con cái',
        career_field: '6. Lĩnh vực',
        career: '7. Nghề nghiệp',
    },
};
export const convertValuePaymentStatus = (status: string) => {
    switch (status) {
        case PaymentConstants.status.ALL:
            return 'Tất cả';
        case PaymentConstants.status.PAID:
            return 'Đã thanh toán';
        case PaymentConstants.status.PENDING:
            return 'Chưa thanh toán';
        case PaymentConstants.status.EXPIRED:
            return 'Đã hết hạn';
        case PaymentConstants.status.FAILED:
            return 'Thanh toán thất bại';
        default:
            return 'Tất cả';
    }
};
export const convertValuePaymentType = (status: string) => {
    switch (status) {
        case PaymentConstants.type.SURVEY:
            return 'Dịch vụ khảo sát';
        case PaymentConstants.type.PLAN:
            return 'Gói dịch vụ';
        default:
            return 'Tất cả';
    }
};

export default PaymentConstants;
